import logger from 'debug';

const debug = logger('wix:debug:one-app-market');
const info = logger('wix:info:one-app-market');
const error = logger('wix:error:one-app-market');

const log = () => {
  return {
    error: msg => {
      error(msg);
    },
    info: msg => {
      info(msg);
    },
    debug: msg => {
      debug(msg);
    }
  };
};

export default log();



// WEBPACK FOOTER //
// ./services/log.js